<template>
  <div>
    <md-tabs :md-active-tab="current_tab" @md-changed="listenerChangeTab">
      <md-tab id="tab-detalle" md-label="Detalles">
        <md-table >
          <md-table-toolbar>
            <h1 class="md-title">Lista Compras
              <p class="md-caption">Total item: {{list_data.mdData.length}}</p>
            </h1>
            <!--<md-menu md-size="big" md-direction="bottom-end" >
              <md-button @click.prevent="showDialog_file=true" >
                <md-icon>backup</md-icon>
              </md-button>
            </md-menu>-->
            <md-menu md-size="big" md-direction="bottom-end">
              <md-button class="md-icon-button" @click="go_to('/period')">
                <md-icon>keyboard_backspace</md-icon>
              </md-button>
            </md-menu>
            <md-menu md-size="big" md-direction="bottom-end">
              <md-button class="md-icon-button" @click="go_to('/compras/nuevo')">
                <md-icon>add</md-icon>
              </md-button>
            </md-menu>
            <md-menu md-size="auto">
              <md-button @click.prevent="handler_open_filter()">
                <md-icon>filter_list</md-icon>
              </md-button>
            </md-menu>
            <md-menu md-size="auto">
              <md-button title="Exportar a excel" class="md-icon-button"
              @click.prevent="printer(null, 'excel')">
                <md-icon>grid_on</md-icon>
              </md-button>
            </md-menu>
            <md-menu md-size="auto">
              <md-button  @click.prevent="printer()" title="Exportar a PDF">
                <md-icon v-if="!sending_request">printer</md-icon>
                <md-progress-spinner v-if="sending_request" class="md-primary"
                :md-diameter="30" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
              </md-button>
            </md-menu>
          </md-table-toolbar>
          <md-table-row>
            <md-table-head class="md-xsmall-hide md-small-hide">Periodo</md-table-head>
            <md-table-head>Fecha doc</md-table-head>
            <md-table-head >Serie</md-table-head>
            <md-table-head >Número</md-table-head>
            <md-table-head >Proveedor</md-table-head>
            <md-table-head >Tipo doc</md-table-head>
            <md-table-head class="md-xsmall-hide md-small-hide" >Bienes</md-table-head>
            <md-table-head class="md-xsmall-hide md-small-hide" >Servicios</md-table-head>
            <md-table-head class="md-xsmall-hide md-small-hide" >Bienes exentos</md-table-head>
            <md-table-head class="md-xsmall-hide md-small-hide" >IVA</md-table-head>
            <md-table-head >Acción</md-table-head>
          </md-table-row>
          <md-table-row v-for="(item, index) in list_data.mdData" :key="item.id"
          :class="{ 'null error-text': !item.status, 'null error-text': !item.conta_aplica}">
            <md-table-cell class="md-xsmall-hide md-small-hide " >
              {{ item.period_date|format_short_date }}
              <br>
              <md-chip class="md-primary" style="font-size:9px;">{{item.store_name}}</md-chip>
            </md-table-cell>
            <md-table-cell >
              {{ item.date_purchase|to_date }}
              <br>
              <md-chip style="font-size: 8px;" title="Fecha creado">
                <md-icon style="font-size: 16px !important;">history</md-icon>
              {{item.created_at|format_date_time}}</md-chip>
              <md-icon v-if="item.place === 'P' || item.place === 'S' ">store</md-icon>
            </md-table-cell>
            <md-table-cell >{{ item.serie }}
              <br>
              <md-chip>#{{item.correlative}}</md-chip>
            </md-table-cell>
            <md-table-cell >
              {{ item.number_invoice_purcharse }}</md-table-cell>
            <md-table-cell >
              {{ item.provider_name }}
              <br>
              <md-icon style="font-size: 16px !important;">person</md-icon>
              <span class="md-caption">{{ item.user_name }}</span>
            </md-table-cell>
            <md-table-cell >
              {{ item.type_document_display }}</md-table-cell>
            <md-table-cell class="md-xsmall-hide md-small-hide">
              {{ item.goods|formatPrice }}
            </md-table-cell>
            <md-table-cell class="md-xsmall-hide md-small-hide">
              {{ item.services|formatPrice }}</md-table-cell>
            <md-table-cell class="md-xsmall-hide md-small-hide">
              {{ item.exempt_goods|formatPrice }}
            </md-table-cell>
            <md-table-cell class="md-xsmall-hide md-small-hide">
              {{ item.iva|formatPrice }}</md-table-cell>
            <md-table-cell  >
              <md-button class="md-icon-button" @click="go_to(`/compras/${item.id}`)">
                <md-icon class="md-size-1x" >edit</md-icon>
              </md-button>
              <md-button :disabled="!item.status"
              class="md-icon-button" @click="delete_document(item, index)">
                  <md-icon class="md-size-1x">delete</md-icon>
              </md-button>
                <md-button class="md-icon-button" @click="go_to(`/compras/view/${item.id}`)">
              <md-icon class="md-size-1x" >visibility</md-icon>
          </md-button>
          </md-table-cell>
          </md-table-row>
        </md-table>
        <md-empty-state v-if="list_data.mdData.length === 0"
          md-icon="free_breakfast"
          md-label="Crear compra"
          md-description="Aún no hay compras registradas, crea la primera.">
          <md-button md-theme="blue-button" class="md-accent md-raised"
            @click="go_to('/compras/nuevo')">
            Crear compra</md-button>
        </md-empty-state>
      </md-tab>
      <md-tab id="tab-libros" md-label="Libros">
        <md-table v-model="list_data_book.mdData" class="margin"
        md-sort="name" md-sort-order="asc" md-card md-fixed-header>
          <md-table-toolbar>
            <h1 class="md-title">Libro Compras</h1>
            <md-menu md-size="big" md-direction="bottom-end">
              <md-button class="md-icon-button" @click="go_to('/')">
                <md-icon>keyboard_backspace</md-icon>
              </md-button>
              <md-menu md-size="big" md-direction="bottom-end">
                <md-button class="md-icon-button" @click="go_to(`/form_compras`)">
                  <md-icon>add</md-icon>
                </md-button>
              </md-menu>
              <md-menu md-size="auto">
                <md-button @click.prevent="showDialog_book=true">
                  <md-icon>filter_list</md-icon>
                </md-button>
              </md-menu>
            </md-menu>
          </md-table-toolbar>
          <md-table-row slot="md-table-row" slot-scope="{ item }">
            <md-table-cell md-label="Autorizacion"
            md-sort-by="authorization">{{item.authorization }}</md-table-cell>
            <md-table-cell md-label="Ejercicio fiscal" md-sort-by="year">
            {{ item.year }}</md-table-cell>
            <md-table-cell md-label="Fecha autorización"
            md-sort-by="date_authorization">{{ item.date_authorization|to_date }}</md-table-cell>
            <md-table-cell md-label="Establecimiento"
                        md-sort-by="store_name">{{ item.store_name }}</md-table-cell>
            <md-table-cell md-label="Activo"
            md-sort-by="status">{{ item.status|status }}</md-table-cell>
            <md-table-cell md-label="Seleccinar"  title="Click para elegir este libro">
              <md-button class="md-icon-button md-primary" @click="set_book(item)">
                <md-icon class="md-size-2x" >done</md-icon>
              </md-button>
            </md-table-cell>
            <md-table-cell md-label="Creado por"
              md-sort-by="creator_name" v-if="item.creator_name">
            {{ item.creator_name }}</md-table-cell>
            <md-table-cell md-label="Creado por"
              md-sort-by="creator_name" v-if="!item.creator_name">-----</md-table-cell>
            <md-table-cell md-label="Editar" >
              <md-button class="md-icon-button" @click="go_to(`/form_compras/${item.id}`)">
                <md-icon class="md-size-1x" >edit</md-icon>
              </md-button>
            </md-table-cell>
          </md-table-row>
          <md-table-pagination
            :md-page-size="rowsPerPage"
            :md-page-options="[3, 5, 10, 15]"
            :md-update="list"
            :md-paginated-data.sync="list_data_book" />
        </md-table>
        <md-empty-state
          md-icon="free_breakfast" v-if="list_data_book.mdData.length === 0"
          md-label="Crear el libro de compras"
          md-description="Aún no hay libros registrados, crea el primero.">
          <md-button
          md-theme="blue-button" class="md-accent
          md-raised" @click="go_to('/form_compras')">Crear libro de compras</md-button>
        </md-empty-state>
      </md-tab>
    </md-tabs>
    <md-progress-bar md-mode="indeterminate" v-if="sending_request" />
    <md-dialog :md-active.sync="showDialog_detalle">
      <md-dialog-title>Filtro documentos
        <md-menu md-size="auto">
          <md-button  @click.prevent="printer()">
            <md-icon v-if="!sending_request">printer</md-icon>
            <md-progress-spinner v-if="sending_request" class="md-primary"
            :md-diameter="30" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
          </md-button>
        </md-menu>
      </md-dialog-title>
      <md-card-content>
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-small-size-100 md-size-20">
            <md-field >
              <label for="period">Año fiscal</label>
              <md-select v-model="fiscal_year_id" @md-selected="get_list_period(true)">
              <md-option value="">----</md-option>
              <md-option :value="item.id"
                v-for="(item, key) in list_years"
                :key="key">{{item.year}}</md-option>
              </md-select>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-20">
            <md-field>
              <label for="period">Periodos</label>
              <md-select v-model="filters_detalle.period_id">
              <md-option value="">----</md-option>
              <md-option :value="item.id"
                v-for="(item, key) in list_periods"
                :key="key">{{item.period}}</md-option>
              </md-select>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100">
            <md-field>
              <label for="stores">Establecimientos</label>
              <md-select v-model="filters_detalle.store">
                <md-option value="">----</md-option>
                <md-option :value="item.id"
                  v-for="(item, key) in list_stores"
                  :key="key">{{item.name}}</md-option>
                </md-select>
            </md-field>
          </div>
        </div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-small-size-100 md-size-40">
            <md-field >
              <label for="total">Tipo documento</label>
              <md-select v-model="filters_detalle.type_document"
              name="movie"
              id="movie"
              :disabled="sending_request"
              >
                <md-option >-----</md-option>
                <md-option :value="item.value"
                v-for="(item, key) in choosen_type_document"
                :key="key">{{item.text}}</md-option>
              </md-select>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-20">
            <md-field >
              <label for="name">Número</label>
              <md-input @keyup.enter="list()"
              v-model="filters_detalle.number_invoice_purcharse"
              type="number" :disabled="sending_request" />
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-20">
            <md-field>
              <label for="serie">Serie</label>
              <md-input @keyup.enter="list()"
              v-model="filters_detalle.serie" type="text" :disabled="sending_request" />
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-20 ">
            <md-field>
              <label for="correlative">Correltivo</label>
              <md-input @keyup.enter="list()"
              v-model="filters_detalle.correlative" type="number" :disabled="sending_request" />
            </md-field>
          </div>
        </div>
        <div class="md-layout md-gutter">
            <div class="md-layout-item md-small-size-100">
              <md-field >
                <label for="nit">Proveedor</label>
                <md-input @keyup.enter="list()"
                v-model="filters_detalle.provider_name" type="text" :disabled="sending_request" />
              </md-field>
            </div>
            <div class="md-layout-item md-size-10 md-small-size-100">
              <md-field class="md-focused">
                <label for="folio">Folio:</label>
                <md-input @change="list()"
                v-model="filters_detalle.folio" type="number" :disabled="sending_request" />
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-20">
              <md-field class="md-focused">
                <label for="date_purchase">Fecha</label>
                <md-input @keyup.enter="list()"
                v-model="filters_detalle.date_purchase" type="date" :disabled="sending_request" />
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-20">
              <md-field>
                <label for="limit">Limite</label>
                <md-input @keyup.enter="list()"
                v-model="filters_detalle.limit" type="number" :disabled="sending_request" />
              </md-field>
            </div>
        </div>
        <div class="md-layout md-gutter">
            <div class="md-layout-item md-small-size-100">
              <md-checkbox v-model="filters_detalle.services">
              SOLO SERVICIOS</md-checkbox>
            <span v-if="filters_detalle.services" style="color: #ff5252;
            font-weight: 500;" for="services">SÍ</span>
            <span v-if="!filters_detalle.services" style="color: #ff5252;
            font-weight: 500;" for="services">NO</span>
            </div>
            <div class="md-layout-item md-size-33 md-small-size-100" >
              <div class="md-layout-item md-small-size-100">
                <md-checkbox v-model="filters_detalle.goods">
                SOLO BIENES</md-checkbox>
              <span v-if="filters_detalle.goods" style="color: #ff5252;
              font-weight: 500;" for="goods">SÍ</span>
              <span v-if="!filters_detalle.goods" style="color: #ff5252;
              font-weight: 500;" for="goods">NO</span>
              </div>
            </div>
            <div class="md-layout-item md-small-size-100">
              <md-checkbox v-model="filters_detalle.fuel">Solo con combustible</md-checkbox>
            <span v-if="filters_detalle.fuel" style="color: #ff5252;
            font-weight: 500;" for="fuel">SÍ</span>
            <span v-if="!filters_detalle.fuel" style="color: #ff5252;
            font-weight: 500;" for="fuel">NO</span>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-125">
              <md-field >
                <label for="num_contabilizado"># contabilizado</label>
                <md-input @keyup.enter="list()"
                v-model="filters_detalle.num_contabilizado"
                type="text" :disabled="sending_request" />
              </md-field>
            </div>
        </div>
        <div class="md-layout-item md-gutter">
          <div class="md-layout-item">
            <md-field>
              <label for="store_contable">Establecimientos contable</label>
              <md-select v-model="filters_detalle.store_contable">
                <md-option value="">----</md-option>
                <md-option :value="item.id"
                  v-for="(item, key) in list_stores"
                  :key="key">{{item.name}}</md-option>
                </md-select>
            </md-field>
          </div>
        </div>
      </md-card-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="showDialog_detalle = false">Cerrar</md-button>
        <md-button class="md-primary"
        @click="reset_filters('filters_detalle')">Limpiar filtro</md-button>
        <md-button class="md-primary" @click="list()">Filtrar</md-button>
      </md-dialog-actions>
    </md-dialog>
    <md-dialog :md-active.sync="showDialog_book">
      <md-dialog-title>Filtro libros</md-dialog-title>
      <md-card-content>
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-small-size-100">
              <md-field >
                <label for="name">Número autorizacion</label>
                <md-input @keyup.enter="list_book(1, rowsPerPage)"
                v-model="filters_book.authorization" type="text" :disabled="sending_request" />
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100">
              <md-field class="md-focused">
                <label for="date_authorization">Fecha autorización</label>
                <md-input @keyup.enter="list_book(1, rowsPerPage)"
                v-model="filters_book.date_authorization" type="date" :disabled="sending_request" />
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100">
              <md-field>
                <label for="stores">Establecimientos</label>
                <md-select v-model="filters_book.store">
                  <md-option value="">----</md-option>
                  <md-option :value="item.id"
                    v-for="(item, key) in list_stores"
                    :key="key">{{item.name}}</md-option>
                  </md-select>
              </md-field>
            </div>
        </div>
      </md-card-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="showDialog_book = false">Cerrar</md-button>
        <md-button class="md-primary"
        @click="reset_filters('filters_book')">Limpiar filtro</md-button>
        <md-button class="md-primary" @click="list_book(1, rowsPerPage)">Filtrar</md-button>
      </md-dialog-actions>
    </md-dialog>
    <md-dialog :md-active.sync="showDialog_file">
      <md-dialog-title>Subir archivo excel</md-dialog-title>
      <md-card-content>
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-small-size-100">
            <upload
                url = "upload_batch_documenst_custom/"
                :periodo = "periodo"
            ></upload>
          </div>
        </div>
      </md-card-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="showDialog_file = false">Cerrar</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>
<script>
import moment from 'moment';
import Swal from 'sweetalert2';
/* eslint-disable */
export default {
  name: 'Purchases',
  created(){
    let current_filters_book = this.get_data_storage(this.name_storage_filter_book)
    if(current_filters_book){
      this.filters_book = current_filters_book
    }
    let current_filters_detalle = this.get_data_storage(this.name_storage_filter_detalle)
    if(current_filters_detalle){
      this.filters_detalle = current_filters_detalle
      if (!this.filters_detalle.period_id) {
        this.filters_detalle.period_id = localStorage.getItem('period')
      }
    }
    this.periodo = localStorage.getItem('period')
    const yearSelected = this.get_data_storage_raw('id_fiscal_year');
    if (yearSelected) {
      this.fiscal_year_id = yearSelected;
    }


    document.addEventListener('keyup', e => {
      if (e.key === 'f4' || e.keyCode === 115) {
        if(this.current_tab === 'tab-detalle'){
          this.handler_open_filter()
        }
        if(this.current_tab === 'tab-libros'){
          this.showDialog_book = true
        }
      }
    })
    this.list(1, this.rowsPerPage)

  },
  components: {
    upload: () => import('../components/UploadFile.vue'),
  },
  data() {
    return {
      periodo: null,
      showDialog_file: false,
      showDialog_detalle: false,
      showDialog_book: false,
      iva_sobre_total: false,
      current_tab: 'tab-detalle',
      name_storage_filter_detalle: 'filter_purchase_detalle',
      name_storage_filter_book: 'filter_purchase_book',
      list_data: {
        mdCount: null,
        mdPage: null,
        mdData: []
      },
      fiscal_year_id: null,
      list_data_book: {
        mdCount: null,
        mdPage: null,
        mdData: []
      },
      list_periods:[],
      list_stores: [],
      list_years:[],
      rowsPerPage: 10,
      filters_detalle: {
        limit: 50,
      },
      filters_book: {
        limit: 50,
      },
      instance: {
        id: null
      },
      url: 'purchase_book_detail/',
      url_book: 'purchase_book/',
      url_fiscal_year: 'fiscal_year',
      sending_request: false,
      choosen_type_document: [
        {value:'D', text: 'DTE FACTURA'},
        {value:'F', text: 'FACTURA'},
        {value:'A', text: 'DTE FACTURA CAMBIARIA'},
        {value:'P', text: 'DTE FACTURA PEQUEÑO CONTRIBUYENTE'},
        {value:'Q', text: 'FACTURA PEQUEÑO CONTRIBUYENTE'},
        {value:'J', text: 'DTE FACTURA CAMBIARIA PEQUEÑO CONTRIBUYENTE'},
        {value:'Y', text: 'FACTURA CAMBIARIA'},
        {value:'R', text: 'DTE NOTA CRÉDITO'},
        {value:'G', text: 'NOTA CRÉDITO'},
        {value:'B', text: 'DTE NOTA DÉBITO'},
        {value:'K', text: 'NOTA DÉBITO'},
        {value:'O', text: 'NOTA DE ABONO'},
        {value:'M', text: 'COMPROBANTE'},
        {value:'E', text: 'DTE FACTURA ESPECIAL'},
        {value:'S', text: 'FACTURA ESPECIAL'},
      ],
    };
  },
  methods: {
    handler_open_filter() {
      this.get_list_years();
      this.get_list_period()
      this.get_list_stores()
      this.showDialog_detalle = true
    },
    get_list_period(set_null=false) {
      const payload = {};
      const self = this;
      if (set_null){
        this.filters_detalle.period_id = null 
      }
      if (!this.fiscal_year_id) return false
      payload.fiscal_year = this.fiscal_year_id

      self.sendRequest_with_url('periods/', payload).then((data) => {
        self.list_periods = data.data;
        self.sending_request = false
      }).catch((error) => {
        self.sending_request = false
        self.handlerError(error)
      });
      return null;
    },
    get_list_years() {
      const payload = {};
      const self = this;
      this.sendRequest_with_url(this.url_fiscal_year, payload).then((data) => {
        self.sending_request = false;
        self.list_years = data.data;
      }).catch((error) => {
        self.sending_request = false;
        self.handlerError(error);
      });
      return null;
    },
    get_list_stores() {
      if (!this.$store.state.company_obj){
        this.$swal.fire('Error!', "Elegir un contribuyente antes", 'error')
        return false
      }
      let payload = {};
      const self = this;
      payload.company = this.$store.state.company_obj.id
      this.sendRequest_with_url('stores/', payload).then((data) => {
        self.list_stores = data.data
        this.sending_request = false
        this.showDialog = false
      }).catch((error) => {
        this.sending_request = false
        this.handlerError(error)
      });
      return null;
    },
    listenerChangeTab(tab_id){
      this.current_tab = tab_id

      if (tab_id==='tab-libros' && this.list_data_book.mdData.length === 0){
        this.list_book(1, this.rowsPerPage)
      }
    },
    go_to(url) {
      this.$router.push(url);
    },
    save_storage(key, data) {
      localStorage.setItem([key], JSON.stringify(data));
    },
    remove_storage(key) {
      localStorage.removeItem([key]);
    },
    get_data_storage(name) {
      return JSON.parse(localStorage.getItem(name));
    },
    get_data_storage_raw(name) {
      return localStorage.getItem(name);
    },
    set_book (instance) {
      if(!instance.status) {
        this.$swal.fire('Error!', 'No se puede elegir este libro, esta inactivo.', 'error')
        return false
      }
      this.remove_storage('book_purchase')
      this.save_storage('book_purchase', instance)
      let libro = this.get_data_storage('book_purchase')
      if (libro){
        this.$swal.fire('Seleccionado!', 'El libro ha sido Seleccionado.', 'success')
        return false
      }
      this.$swal.fire('Error!', 'Paso algo y el libro no fue elegido.', 'error')

    },
    reset_filters: function (name_filter) {
      this[name_filter] = { limit: 50}
      if (name_filter === 'filters_detalle'){
        this.list()
      }
      if (name_filter === 'filters_book'){
        this.list_book()
      }
    },
    list_book(page, pageSize, sort, sortOrder) {
      if (!this.$store.state.company_obj){
        this.$swal.fire('Error!', "Elegir un contribuyente antes", 'error')
        return false
      }
      let payload = {};
      const self = this;
      payload.paginate = "True"
      payload.page = page
      payload.per_page = pageSize
      if (this.sending_request) return false
      this.sending_request = true
      payload.company = this.$store.state.company_obj.id
      payload.store = this.$store.state.store_obj.id

      if (Object.keys(this.filters_book).length > 0){
        Object.assign(payload, this.filters_book)
      }
      if (!payload.store){
        delete payload.store
      }
      
      this.sendRequest_with_url(this.url_book, payload).then((data) => {
        self.rowsPerPage = 50
        self.list_data_book = {
          mdCount: data.data.count,
          mdPage: page,
          mdData: data.data.results
        }
        this.sending_request = false
        this.save_storage(this.filter_purchase_book, this.filters_book,)
        this.showDialog_book = false
      }).catch((error) => {
        this.sending_request = false
        this.handlerError(error)
      });
      return null;
    },
    printer(rango=null, format="pdf") {
      if (!this.$store.state.company_obj){
        this.$swal.fire('Error!', "Elegir un contribuyente antes", 'error')
        return false
      }
      let payload = {};
      payload.printer = "True"
      if (format==='excel') {
        payload.printer = "excel"
      }
      payload.company = this.$store.state.company_obj.id
      
      payload.rango  = rango

      if (rango === 'year'){
        payload.fecha = moment().format('YYYY-MM-DD');
      }
      if (rango === 'month'){
        payload.fecha = moment().startOf('month').format('YYYY-MM-DD');
      }
      if (rango === 'last_year'){
        payload.fecha = moment().subtract(1, 'years').date(1).format('YYYY-MM-DD');
      }
      if (rango === 'last_month'){
        payload.fecha = moment().subtract(1, 'months').date(1).format('YYYY-MM-DD');
      }
      if(this.filters_detalle.period_id) {
        payload.period_id = this.filters_detalle.period_id;
      }
      payload.fiscal_year = this.fiscal_year_id

      if(this.filters_detalle.type_document) {
        payload.type_document = this.filters_detalle.type_document;
      }

      if(this.filters_detalle.store) {
        payload.store = this.filters_detalle.store;
      }
      if(this.filters_detalle.store_contable) {
        payload.store_contable = this.filters_detalle.store_contable;
      }
      if(this.filters_detalle.num_contabilizado) {
        payload.num_contabilizado = this.filters_detalle.num_contabilizado;
      }
      if(this.filters_detalle.del) {
        payload.del = this.filters_detalle.del;
      }
      if(this.filters_detalle.al) {
        payload.al = this.filters_detalle.al;
      }
      if(this.filters_detalle.folio) {
        payload.folio = this.filters_detalle.folio;
      }

      if (rango == null){
        if(this.filters_detalle.al) {
          delete payload.rango
          delete payload.fecha
        }
        if(this.filters_detalle.del) {
          delete payload.rango
          delete payload.fecha
        }
      }
      if (rango != null){
        delete payload.del
        delete payload.al
      }
      if (this.iva_sobre_total) {
        payload.iva_sobre_total = "True"
      }
      
      if (this.sending_request) return false
      this.sending_request = true

      this.sendRequest_with_url(this.url, payload).then((data) => {
        if (data.headers['content-type'] == 'application/pdf'){
          this.sending_request = false
          var blob = new Blob([data.data], { type: 'application/pdf;charset=utf-8' });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = 'report_purchase_book.pdf';
          window.open(link, '_blank');
          return false;
        }
        if (payload.printer==='excel') {
          this.to_excel(data)
          return false;
        }

        this.sending_request = false
      }).catch((error) => {
        console.log(error)
        this.sending_request = false
        this.handlerError(error)
      });
    },
    to_excel(data) {
      let payload = {};
      payload.printer = "excel"
      let datetimenow = new Date();
      let datenow = datetimenow.getDate() + '-'+datetimenow.getMonth() + '-' + datetimenow.getFullYear();
      let timenow = datetimenow.getHours() + datetimenow.getMinutes() +   datetimenow.getSeconds();
      let nameexcel ='Detalle de compras '+datenow+' '+timenow;

      var uri = 'data:application/vnd.ms-excel;base64,';
      var template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>'; 
      var base64 = function(s) {
        return window.btoa(unescape(encodeURIComponent(s)))
      };

      var format = function(s, c) {
        return s.replace(/{(\w+)}/g, function(m, p) {
          return c[p];
        })
      };

      var htmls = data.data;

      var ctx = {
        worksheet : 'Worksheet',
        table : htmls
      }

      var link = document.createElement("a");
      link.pars
      link.download = nameexcel+".xls";
      link.href = uri + base64(format(template, ctx));
      link.click();
      this.sending_request = false
    },
    list(page, pageSize) {
      if (!this.$store.state.company_obj){
        this.$swal.fire('Error!', "Elegir un contribuyente antes", 'error')
        return false
      }
      let payload = {};
      const self = this;
      if (this.sending_request) return false
      this.sending_request = true
      payload.company = this.$store.state.company_obj.id
      
      if (Object.keys(this.filters_detalle).length > 0){
        Object.assign(payload, this.filters_detalle)
      }
      if (!this.filters_detalle.period_id) {
        delete payload.period_id
      }
      if (!this.filters_detalle.store) {
        delete payload.store
      }
      if (!this.filters_detalle.store_contable) {
        delete payload.store_contable
      }
      if (!this.filters_detalle.num_contabilizado) {
        delete payload.num_contabilizado
      }
      if (!this.filters_detalle.type_document) {
        delete payload.type_document
      }
      if (!payload.number_invoice_purcharse){
        delete payload.number_invoice_purcharse
      }
      if (!payload.serie){
        delete payload.serie
      }
      if (!payload.serie){
        delete payload.serie
      }
      if (!payload.fiscal_year_id){
        delete payload.fiscal_year_id
      }
      if (!payload.correlative){
        delete payload.correlative
      }

      if (this.iva_sobre_total) {
        payload.iva_sobre_total = "True"
      }

      this.sendRequest_with_url(this.url, payload).then((data) => {
        self.rowsPerPage = 50
        self.list_data = {
          mdData: data.data
        }
        this.save_storage(this.name_storage_filter_detalle, this.filters_detalle,)
        this.sending_request = false
        this.showDialog_detalle = false
      }).catch((error) => {
        this.sending_request = false
        this.handlerError(error)
      });
      return null;
    },
    delete_document(item, index){
      if (item.id){
        const self = this
        Swal.fire({
            title: "¿Esta seguro?",
            text: "El registro será deshabilitado y no se podrá recuperar.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            showLoaderOnConfirm: true,
            preConfirm: function (email) {
                const payload = item
               return self.deleteRequestDocument(payload).then(function (data){
                  Swal.fire(
                    'Anulado!',
                    'El registro ha sido deshabilitado.',
                    'success'
                  )
                  self.sending = false
                  self.$set(self.list_data.mdData, index, data.data)
                }).catch(function (error) {
                  self.sending = false
                  if (typeof (error.response.data) === 'object') {
                    const result = error.response.data
                    Object.entries(result).forEach(
                      ([key, value]) => self.$swal.fire('Error!', key + ': ' + value, 'error')
                    )
                    return false
                  }
                  self.$swal.fire('Error!', error.response.data, 'error')
                })
            },
          }).then((result) => {
            if (result.isConfirmed) {
            }else {
              item.edit = false
              Swal.fire(
                'Cancelado',
                'El registro esta seguro.',
                'error'
              )

            }
        });
      }
    },
    async sendRequest(payload) {
      const result = await this.$http.get(this.url,{params:  payload});
      // const result = await this.$http.get(this.url, payload);
      return result;
    },
    async sendRequest_with_url(url, payload) {
      // const result = await this.$http.get(this.url, payload);
      const result = await this.$http.get(url,{params:  payload});
      return result;
    },
    async deleteRequestDocument(payload) {
      const result = await this.$http.delete(`${this.url}${payload.id}/`, payload)
      return result
    },

    handlerError: function (error) {
      if (typeof (error.response.data) === 'object') {
        const result = error.response.data
        Object.entries(result).forEach(
          ([key, value]) => this.$swal.fire('Error!', key + ': ' + value, 'error')
        )
        return false
      }
      this.$swal.fire('Error!', error.response.data, 'error')
    },
  },
  filters: {
    status_to_text(value){
      if (value) return 'Sí';
      return 'No';
    },
    to_date(value) {
      if (!value ) return '-----'
      return moment(value, 'YYYY-MM-DD', 'es').format('DD/MM/YYYY')
    },
    
    format_date_time: function (value) {                     
      return moment(value, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss');
    },
    format_short_date: function (value) {                     
      return moment(value, 'YYYY-MM-DD HH:mm:ss', 'es').format('MMMM YYYY').toUpperCase();
    },
    status(value) {
      if (value) return 'Si'
      return 'No'
    },
    format_number: function (value) {
      if (!value) return ''
        return isNaN(value) ? 0 : parseFloat(value).toFixed(2)
    },
    formatPrice(value) {
      const val = (value / 1).toFixed(2).replace('.', '.');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
  },
};

</script>
<style lang="scss" scoped>
  .md-table + .md-table {
    margin-top: 16px
  }
  .avatar img {
    max-width: 30px;
  }
</style>
<style lang="css" scoped>
  .on-over {
    cursor: pointer;
  }
  .fa-refresh {
      -webkit-animation: infinite-spinning 5s normal linear infinite;
      animation: infinite-spinning 5s normal linear infinite;
  }
  .null{
    text-decoration: line-through;
  }
  .fade-enter-active {
    transition: all .5s ease;
  }
  .fade-leave-active {
    transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .fade-enter, .fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateX(10px);
    opacity: 0;
  }
  .margin{
    margin-bottom: 50px;
  }
  .md-card-content{
    overflow-y: auto;
  }


  @keyframes infinite-spinning {
    0% {
       -webkit-transform: rotate3d(0, 0, 1, 0deg);
       transform: rotate3d(0, 0, 1, 0deg);
     }
     25% {
       -webkit-transform: rotate3d(0, 0, 1, 90deg);
       transform: rotate3d(0, 0, 1, 90deg);
     }
     50% {
       -webkit-transform: rotate3d(0, 0, 1, 180deg);
       transform: rotate3d(0, 0, 1, 180deg);
     }
     75% {
       -webkit-transform: rotate3d(0, 0, 1, 270deg);
       transform: rotate3d(0, 0, 1, 270deg);
     }
     100% {
       -webkit-transform: rotate3d(0, 0, 1, 360deg);
       transform: rotate3d(0, 0, 1, 360deg);
     }
  }
  .bounce-enter-active {
    animation: bounce-in .5s;
  }
  .bounce-leave-active {
    animation: bounce-in .5s reverse;
  }
  @keyframes bounce-in {
    0% {
      transform: scale(0);
    }
    50% {
      transform: scale(1.2);
    }
    100% {
      transform: scale(1);
    }
  }
  .error-text {
    color: #958c8c;
  }
</style>